'use client'
import * as React from 'react'
import styles from './toast.module.scss'
import * as ReactDOM from 'react-dom'
import cls from 'classnames'

type TListener = () => void
export type TMessage = {
  message: string
  duration?: number
  position?: 'top' | 'bottom' | 'center'
  [key: string]: any
}
const defaultDuration = 4000
let messages: TMessage[] = []
let listeners: TListener[] = []

const messageStore = {
  addMessage(message: TMessage | string) {
    return new Promise((resolve) => {
      if (typeof message === 'string') {
        message = { message, duration: defaultDuration, _id: `${Date.now()}_${Math.random()}` }
      }
      messages = [...messages, { ...message, _id: `${Date.now()}_${Math.random()}` }]
      emitChange()
      setTimeout(() => {
        messages = messages.slice(1)
        emitChange()
        resolve(null)
      }, message.duration || defaultDuration)
    })
  },
  subscribe(listener: TListener) {
    listeners = [...listeners, listener]
    return () => {
      listeners = listeners.filter((l) => l !== listener)
    }
  },
  getSnapshot() {
    return messages
  },
  getServerSnapshot() {
    return messages
  },
}

function emitChange() {
  for (const listener of listeners) {
    listener()
  }
}

type TToasterProps = {
  style?: React.CSSProperties // 支持外部定制样式
  render?: (message: TMessage[]) => React.ReactNode // 支持外部定制渲染
  className?: string // 支持外部定制类名
}

export function Toaster({ style, render, className }: TToasterProps) {
  const msgs = React.useSyncExternalStore<TMessage[]>(
    messageStore.subscribe,
    messageStore.getSnapshot,
    messageStore.getServerSnapshot
  )
  if (typeof window === 'undefined') return null
  const toastBox = msgs.length ? (
    render ? (
      render(msgs)
    ) : (
      <div
        className={cls('f28', className || styles.toast, {
          [msgs[msgs.length - 1].position || 'center']: true,
        })}
        style={style}
      >
        {msgs[msgs.length - 1].message}
      </div>
    )
  ) : null
  return ReactDOM.createPortal(toastBox, window.document.body)
}

export default function toast(message: TMessage | string) {
  return messageStore.addMessage(message)
}
